import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {Sealink} from '../../Interfaces/Sealink';
import * as XLSX from 'xlsx';
import {SealinkExcel} from '../../Interfaces/SealinkExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-sealink-inquiry',
  templateUrl: './sealink-inquiry.component.html',
  styleUrls: ['./sealink-inquiry.component.css']
})
export class SealinkInquiryComponent implements OnInit {

  public  myUser: User;
  sealinkData: MatTableDataSource<Sealink>;
  public cColumns: string[];
  subscription: Subscription;
  private clientRequest: ClientRequest;
  private seaLinks: Sealink [] = [];
  private seaLinkDetail: Sealink;
  showScreen: boolean = false;
  truckSSLCol: string = "Truck/SSL Life Cycle";
  driverExpCol: string = "Card Expiration";
  truckSSLStatusCol: string = "Truck/SSL Status";
  drvLifeCycleCol: string = "Driver Life Cycle";
  showScreenPhone: boolean = false;
  phoneApp: boolean = false;
  ipadApp: boolean = false;
  search1: UntypedFormControl;
  private  date1: Date;
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  private sealinkExcelArray: SealinkExcel[] = [];
  private sealinkExcel: SealinkExcel;

  public savedList: string;
  public savedLists : {code:string, description:string}[] = [];
  sealinkNum: string;
  submitted: boolean = false;
  noSealink: boolean = false;
  noSealinkFound: boolean = false;

  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.sealinkData != undefined) {
      this.sealinkData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.sealinkData != undefined) {
      this.sealinkData.paginator = pag;
    }
  }
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;

  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showScreen = false;
    }
  }


  exportExcel() {
    this.sealinkExcelArray = [];
    for (var xx=0; xx<this.sealinkData.filteredData.length; xx++){
      this.sealinkExcel = {} as SealinkExcel ;
      this.sealinkExcel.CardId = this.sealinkData.filteredData[xx].card_id;
      this.sealinkExcel.Driver = this.sealinkData.filteredData[xx].name;
      this.sealinkExcel.DriverExpiration = this.sealinkData.filteredData[xx].driver_expiration;
      this.sealinkExcel.Suspended = this.sealinkData.filteredData[xx].suspended;
      this.sealinkExcel.DriverStatus = this.sealinkData.filteredData[xx].driver_status;
      this.sealinkExcel.DriverLifeCycle = this.sealinkData.filteredData[xx].driver_life_cycle_state;
      this.sealinkExcel.TruckerExpiration = this.sealinkData.filteredData[xx].driver_company_expiration;
      this.sealinkExcelArray.push(this.sealinkExcel);

    }



    const workSheet = XLSX.utils.json_to_sheet(this.sealinkExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:20},
      {wch:20},
      {wch:10},
      {wch:15},
      {wch:15},
      {wch:15},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SealinkInquiry');
    XLSX.writeFile(workBook, 'sealinkInquiry.xlsx');
  }


  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent,private  globalEventsManager: GlobalEventsManager) {
    this.cColumns = ["card_id","name", "driver_expiration","suspended", "driver_status","driver_life_cycle_state","driver_company_expiration"];

    this.myUser = this.myApp.user;
/*
                this.myUser = {} as User;
                this.myUser.active ="Y"
                this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
                this.myUser.address_2 = null
                this.myUser.company_code ="M1230"
                this.myUser.company_name= "MAHER TERMINALS, LLC"
                this.myUser.city= "HOUSTON"
                this.myUser.email_address= null
                this.myUser.fax_number= null
                this.myUser.first_name= "Csp Craig"
                this.myUser.last_name= "Miller"
                this.myUser. maherError= null
                this.myUser.old_password= null
                this.myUser.password= ""
                this.myUser.phone_number= null
                this.myUser.company_scac= null;
                this.myUser.state= "TX"
                this.myUser.userMenuReportItemsView= null
                this.myUser.user_gkey= "8237887"
                this.myUser.role= "AGENT"
            //   this.myUser.role= "HAULIER"
                this.myUser.username="CSPCRAIG"
                this.myUser.zip="07201"
                this.myUser.canSeeAllData = "0";



 */


  }

  ngOnInit() {
    this.search1 = new UntypedFormControl();
    this.savedLists = [];
    this.savedLists.push({"code": "All Sealinks", "description": "All Sealinks"});
    this.savedLists.push({"code": "Active Sealinks", "description": "Active Sealinks"});
    this.savedLists.push({"code": "Terminated Sealinks", "description": "Terminated Sealinks"});
    this.savedList = this.savedLists[0].code;
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }
    if (window.innerWidth > 750 && window.innerWidth <1290){
      this.ipadApp = true;
    }
  }

  getNiceDate(dateIn: string): string {
    this.date1 =  new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options);
  }



  getSealinkInfo(){
    this.submitted = true;
    this.noSealink = false;
    this.noSealinkFound = false;
    this.showScreenPhone = false;


    if (this.sealinkNum==null){
      this.noSealink=true;
      return;
    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.clientRequest.requestData[0] = this.sealinkNum;

    const lhsUserObs$ = this.queryService.getSealink(this.clientRequest)

    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.seaLinkDetail = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        }
      },
      () => {
        if (this.seaLinkDetail==null){
          this.noSealinkFound = true;
        }else{
          this.formatDetailScreen();
          this.submitted = false;
          this.showScreenPhone = true;
        }




      });
  }


   getSealinks(){
    this.noSealink = false;
    this.noSealinkFound = false;
    this.showScreenPhone = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    var lhsUserObs$;
    if (this.savedList.includes("All")){
      lhsUserObs$ = this.queryService.getAllSealinks(this.clientRequest);
    }else if (this.savedList.includes("Active")){
      lhsUserObs$ = this.queryService.getActiveSealinks(this.clientRequest);
    }else{
      lhsUserObs$ = this.queryService.getTerminatedSealinks(this.clientRequest);
    }


    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.seaLinks = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        }
      },
      () => {

        this.showScreen = true;
        this.search1.reset();

        if (window.innerWidth<1601){
          this.truckSSLCol = "Trk/SSL Life";
          this.driverExpCol = "Card Exp.";
          this.truckSSLStatusCol = "Trk/SSL Status";
          this.drvLifeCycleCol = "Drv. Life Cycle";
        }
        for (var items of this.seaLinks){
          if (items.driver_company_expiration!=null){
            items.driver_company_expiration = this.getNiceDate(items.driver_company_expiration);
          }
          if (items.suspended!=null){
            items.suspended = this.getNiceDate(items.suspended);
          }
          if (items.driver_expiration!=null){
            items.driver_expiration = this.getNiceDate(items.driver_expiration);
          }
        }


        this.sealinkData = new MatTableDataSource<Sealink>(this.seaLinks);

        if (window.innerWidth > 750 && window.innerWidth <1150){
          this.ipadAppear = false;
        }


        this.sealinkData.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'driver_expiration': return new Date(item.driver_expiration);
            case 'driver_company_expiration': return new Date(item.driver_company_expiration);
            default: return item[property];
          }
        };

      });
  }

  leaveScreen(){
    this.showScreen = false;
    this.myApp.showCharts();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.sealinkData.filter = filterValue;
  }

  formatDetailScreen() {
    if (this.seaLinkDetail.name == null) {
      this.seaLinkDetail.name = " ";
    }
    if (this.seaLinkDetail.card_id == null) {
      this.seaLinkDetail.card_id = " ";
    }
    if (this.seaLinkDetail.driver_expiration == null) {
      this.seaLinkDetail.driver_expiration = " ";
    }else{
      this.seaLinkDetail.driver_expiration = this.getNiceDate(this.seaLinkDetail.driver_expiration);
    }
    if (this.seaLinkDetail.driver_status == null) {
      this.seaLinkDetail.driver_status = " ";
    }
    if (this.seaLinkDetail.driver_life_cycle_state == null) {
      this.seaLinkDetail.driver_life_cycle_state = " ";
    }
    if (this.seaLinkDetail.trucker_driver_expiration == null) {
      this.seaLinkDetail.trucker_driver_expiration = " ";
    }
    if (this.seaLinkDetail.id == null) {
      this.seaLinkDetail.id = " ";
    }
    if (this.seaLinkDetail.driver_company_expiration == null) {
      this.seaLinkDetail.driver_company_expiration = " ";
    }else{
      this.seaLinkDetail.driver_company_expiration = this.getNiceDate(this.seaLinkDetail.driver_company_expiration);
    }
    if (this.seaLinkDetail.truck_company_status == null) {
      this.seaLinkDetail.truck_company_status = " ";
    }
    if (this.seaLinkDetail.tc_life_cycle_state == null) {
      this.seaLinkDetail.tc_life_cycle_state = " ";
    }

  }
}
